import * as requester from '../utils/requester';

export const createRseeDiscountRequest = reqObject => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        route: 'v1/rsee-discount',
        method: 'POST',
        data: reqObject,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const getMyRseeDiscountsList = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/rsee-discount?${query}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllRseeDiscountRequests = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/rsee-discount/requested?${query}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllRseeDiscountRequestArchives = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/rsee-discount/archived?${query}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchRseeDiscountRequestDetailsById = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/rsee-discount/${id}`,
        method: 'GET'
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateRseeDiscountRequestStatus = (id, status, rejectionReason) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/rsee-discount/${status == 'approve' ? 'confirm' : 'reject'}`,
        method: 'PUT',
        data: {
          id,
          rejectionReason
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const activateRseeDiscount = (id) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: 'v1/rsee-discount/confirm',
        method: 'PUT',
        data: {
          id,
        },
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
